import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daohqscvvta8mhpmeppg";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("Thank you — you are on the list.");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMessage =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "Something went wrong.";

      if (response.ok && code === "OK") {
        setStatus("success");
        setMessage("Thank you — you are on the list for health updates.");
        form.reset();
      } else {
        setStatus("error");
        setMessage(String(serverMessage));
      }
    } catch {
      setStatus("error");
      setMessage("We could not reach the server. Please try again.");
    }
  };

  return (
    <div className="rounded-lg bg-background-50/10 p-1">
      <form
        id="newsletter-signup-form"
        data-readdy-form
        onSubmit={handleSubmit}
        className="flex flex-col gap-2 sm:flex-row"
      >
        <label className="sr-only" htmlFor="newsletter-email">
          Email address
        </label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="Enter your email address"
          className="w-full rounded-md border border-background-50/20 bg-background-50/95 px-4 py-2.5 font-body text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-secondary-400"
        />
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="form-honeypot-field"
        />
        <button
          type="submit"
          className="cursor-pointer whitespace-nowrap rounded-md bg-gradient-to-br from-secondary-500 to-secondary-400 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:from-secondary-600 hover:to-secondary-500"
        >
          Subscribe
        </button>
      </form>
      {status !== "idle" ? (
        <p
          role="status"
          className={`mt-2 font-body text-xs ${status === "success" ? "text-background-100" : "text-secondary-200"}`}
        >
          {message}
        </p>
      ) : null}
    </div>
  );
}